import { useCallback, useState } from "react";

type TryCatchState = {
  error: null | string | any;
  success: boolean;
  trying: boolean;
  response: any;
};

const useTryCatch = <T extends any>(
  onPerform: (_args: T) => Promise<void>,
  deps: any[] = []
): [TryCatchState, (_args: T) => Promise<void>] => {
  const [state, setState] = useState<TryCatchState>({
    error: null,
    success: false,
    trying: false,
    response: undefined
  });

  const depsOnPerform = useCallback(onPerform, deps);
  const onAction = useCallback(
    async (args: any) => {
      setState({ error: null, success: false, trying: true, response: undefined });

      try {
        const result = await depsOnPerform(args);
        setState({ error: null, success: true, trying: false, response: result });
      } catch (error) {
        setState({ error, success: false, trying: false, response: null });
      }
    },
    [depsOnPerform]
  );

  return [state, onAction];
};

export default useTryCatch;
